import { jsxs as r, jsx as c } from "react/jsx-runtime";
import z from "clsx";
const S = (n) => z(n), s = "dds-inline-notification-v0142";
function p({
  children: n,
  className: t = "",
  variant: e = "error",
  prefixOverride: i,
  showPrefix: o = !0,
  ...a
}) {
  const C = {
    [s]: !0,
    [`${s}--${e}`]: !0,
    [t]: t.length > 0
  }, M = {
    note: "Note",
    reminder: "Reminder",
    caution: "Caution",
    verify: "Verify",
    success: "Success",
    error: "Error",
    invalid: "Invalid",
    "system-error": "System error"
  }, l = {
    note: /* @__PURE__ */ c(
      "path",
      {
        d: `M4,0C1.79,0,0,1.79,0,4s1.79,4,4,4s4-1.79,4-4S6.21,0,4,0z M4,6.37H3.43c-0.24,0-0.42-0.23-0.36-0.46l0.45-1.82
H3.43c-0.21,0-0.37-0.17-0.37-0.38c0-0.2,0.16-0.37,0.37-0.37H4c0.24,0,0.42,0.23,0.36,0.46L3.9,5.63H4c0.21,0,0.37,0.16,0.37,0.37
S4.21,6.37,4,6.37z M4,2.86c-0.32,0-0.57-0.26-0.57-0.57c0-0.32,0.25-0.58,0.57-0.58s0.57,0.26,0.57,0.58C4.57,2.6,4.32,2.86,4,2.86
z`
      }
    ),
    reminder: /* @__PURE__ */ c(
      "path",
      {
        d: `M4,0C1.79,0,0,1.79,0,4s1.79,4,4,4s4-1.79,4-4S6.21,0,4,0z M4,6.37H3.43c-0.24,0-0.42-0.23-0.36-0.46l0.45-1.82
H3.43c-0.21,0-0.37-0.17-0.37-0.38c0-0.2,0.16-0.37,0.37-0.37H4c0.24,0,0.42,0.23,0.36,0.46L3.9,5.63H4c0.21,0,0.37,0.16,0.37,0.37
S4.21,6.37,4,6.37z M4,2.86c-0.32,0-0.57-0.26-0.57-0.57c0-0.32,0.25-0.58,0.57-0.58s0.57,0.26,0.57,0.58C4.57,2.6,4.32,2.86,4,2.86
z`
      }
    ),
    caution: /* @__PURE__ */ c(
      "path",
      {
        d: `M7.93,6.91L4.52,0.54c-0.22-0.41-0.82-0.41-1.04,0L0.07,6.91C-0.14,7.3,0.14,7.77,0.59,7.77h6.82
C7.86,7.77,8.14,7.3,7.93,6.91z M3.56,2.94C3.56,2.7,3.76,2.5,4,2.5s0.44,0.2,0.44,0.44V4.4c0,0.25-0.2,0.44-0.44,0.44
S3.56,4.65,3.56,4.4V2.94z M4,6.6c-0.32,0-0.59-0.26-0.59-0.59c0-0.32,0.27-0.58,0.59-0.58s0.59,0.26,0.59,0.58
C4.59,6.34,4.32,6.6,4,6.6z`
      }
    ),
    verify: /* @__PURE__ */ c(
      "path",
      {
        d: `M7.93,6.91L4.52,0.54c-0.22-0.41-0.82-0.41-1.04,0L0.07,6.91C-0.14,7.3,0.14,7.77,0.59,7.77h6.82
C7.86,7.77,8.14,7.3,7.93,6.91z M3.56,2.94C3.56,2.7,3.76,2.5,4,2.5s0.44,0.2,0.44,0.44V4.4c0,0.25-0.2,0.44-0.44,0.44
S3.56,4.65,3.56,4.4V2.94z M4,6.6c-0.32,0-0.59-0.26-0.59-0.59c0-0.32,0.27-0.58,0.59-0.58s0.59,0.26,0.59,0.58
C4.59,6.34,4.32,6.6,4,6.6z`
      }
    ),
    success: /* @__PURE__ */ c(
      "path",
      {
        d: `M4,0C1.79,0,0,1.79,0,4s1.79,4,4,4s4-1.79,4-4S6.21,0,4,0z M5.8,2.97l-2,2.75C3.67,5.91,3.4,5.93,3.23,5.77
l-1-1c-0.14-0.15-0.14-0.39,0-0.54c0.15-0.14,0.39-0.14,0.54,0l0.68,0.69L5.2,2.53c0.12-0.17,0.35-0.21,0.52-0.08
C5.89,2.57,5.93,2.8,5.8,2.97z`
      }
    ),
    error: /* @__PURE__ */ c(
      "path",
      {
        d: `M4,0C1.79,0,0,1.79,0,4s1.79,4,4,4s4-1.79,4-4S6.21,0,4,0z M3.57,2.29c0-0.24,0.19-0.43,0.43-0.43
s0.43,0.19,0.43,0.43V4c0,0.24-0.19,0.43-0.43,0.43S3.57,4.24,3.57,4V2.29z M4,6.29c-0.32,0-0.57-0.26-0.57-0.58
C3.43,5.4,3.68,5.14,4,5.14S4.57,5.4,4.57,5.71C4.57,6.03,4.32,6.29,4,6.29z`
      }
    ),
    invalid: /* @__PURE__ */ c(
      "path",
      {
        d: `M4,0C1.79,0,0,1.79,0,4s1.79,4,4,4s4-1.79,4-4S6.21,0,4,0z M3.57,2.29c0-0.24,0.19-0.43,0.43-0.43
s0.43,0.19,0.43,0.43V4c0,0.24-0.19,0.43-0.43,0.43S3.57,4.24,3.57,4V2.29z M4,6.29c-0.32,0-0.57-0.26-0.57-0.58
C3.43,5.4,3.68,5.14,4,5.14S4.57,5.4,4.57,5.71C4.57,6.03,4.32,6.29,4,6.29z`
      }
    ),
    "system-error": /* @__PURE__ */ c(
      "path",
      {
        d: `M4,0C1.79,0,0,1.79,0,4s1.79,4,4,4s4-1.79,4-4S6.21,0,4,0z M3.57,2.29c0-0.24,0.19-0.43,0.43-0.43
s0.43,0.19,0.43,0.43V4c0,0.24-0.19,0.43-0.43,0.43S3.57,4.24,3.57,4V2.29z M4,6.29c-0.32,0-0.57-0.26-0.57-0.58
C3.43,5.4,3.68,5.14,4,5.14S4.57,5.4,4.57,5.71C4.57,6.03,4.32,6.29,4,6.29z`
      }
    )
  };
  return /* @__PURE__ */ r("span", { className: S(C), ...a, children: [
    /* @__PURE__ */ c("svg", { className: `${s}__glyph`, viewBox: "0 0 8 8", children: l[e] }),
    /* @__PURE__ */ r("span", { className: `${s}__content`, children: [
      o && /* @__PURE__ */ r("span", { className: `${s}__label`, children: [
        i ?? M[e],
        ":"
      ] }),
      n
    ] })
  ] });
}
export {
  p as InlineNotification
};
//# sourceMappingURL=index.js.map
